import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=575a672c&"
import script from "./createOrder.vue?vue&type=script&lang=ts&"
export * from "./createOrder.vue?vue&type=script&lang=ts&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=575a672c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports